import Events from 'components/Events/Events';
import EventsFilters from 'components/EventsFilters/EventsFilters';
import Title from 'components/Title/Title';
import withCountry from 'enhancers/withCountry';
import withEventsPageQuery, {
  ICountdownText,
  IEventsPageText,
  WithEventsPageQueryProps,
} from 'enhancers/withEventsPageQuery';
import withLanguageState, { WithLanguageProps } from 'enhancers/withLanguageState';
import * as React from 'react';
import Placeholder from 'react-placeholder';
import styled from 'styled-components';
import { getTextColor } from 'utils/colors';
import Section from 'wrappers/Section/Section';

type Props = WithEventsPageQueryProps & WithLanguageProps;

export const EventsPage: React.SFC<Props> = props => {
  const background =
    !props.loading &&
    props.data &&
    props.data.fetch.Common.Events &&
    props.data.fetch.Common.Events.BackgroundColor
      ? props.data.fetch.Common.Events.BackgroundColor
      : '#ffffff';
  const color =
    !props.loading &&
    props.data &&
    props.data.fetch.Common.Events &&
    props.data.fetch.Common.Events.HeaderColor
      ? props.data.fetch.Common.Events.HeaderColor
      : getTextColor(background);

  let text: IEventsPageText & ICountdownText = {
    CountdownText: '',
    DaysText: '',
    HoursText: '',
    MinutesText: '',
    OldestText: '',
    RecentText: '',
    SecondsText: ''
  };

  if (!props.loading && props.data) {
    const EventsPageData = props.data.fetch.Country.EventsPage;
    const HomePageData =
      props.data.fetch.Country.HomePage.Splash &&
      props.data.fetch.Country.HomePage.Splash.Countdown
        ? props.data.fetch.Country.HomePage.Splash.Countdown
        : ({} as { [key: string]: string });
    text = {
      CountdownText: HomePageData.CountdownText,
      DaysText: HomePageData.DaysText,
      HoursText: HomePageData.HoursText,
      MinutesText: HomePageData.MinutesText,
      OldestText: EventsPageData.OldestText,
      RecentText: EventsPageData.RecentText,
      SecondsText: HomePageData.SecondsText
    };
    Object.keys(text).forEach(key => (text[key] = props.getText(text[key])));
  }

  return (
    <Container style={{ background, color }}>
      <StyledSection>
        <Placeholder
          showLoadingAnimation={true}
          ready={!props.loading}
          rows={1}
        >
          <StyledTitle color={color}>
            {!props.loading &&
              props.data &&
              props.getText(props.data.fetch.Country.EventsPage.Header)}
          </StyledTitle>
        </Placeholder>
        <EventsFilters />
        <Events />
      </StyledSection>
    </Container>
  );
};

const StyledTitle = styled(Title)<{ color: string }>`
  text-align: center;
  margin-top: 0;
  color: ${p => p.color};
`;

const Container = styled.div`
  padding-top: 25px;
`;

const StyledSection = styled(Section)``;

export default withLanguageState(withCountry(withEventsPageQuery(EventsPage)));



// WEBPACK FOOTER //
// ./src/pages/EventsPage/EventsPage.tsx